import { useState } from 'react';
import { formatDateOnly } from '../../../../../utils/dates';
import type { PatientsBrowse } from '../usePatientsBrowse';
import { ChipDateField } from './ChipDateField';
import { ChipOptionList } from './ChipOptionList';
import { LAST_SCAN_OPTIONS, lastScanChipValue, type LastScanPreset } from './chipPresets';
import { FilterBar } from './FilterBar';
import { FilterChip } from './FilterChip';

interface PatientFilterBarProps {
    browse: PatientsBrowse;
    today: string;
}

function LastScanChip({ browse, today }: PatientFilterBarProps) {
    const { lastScan, lastScanSince } = browse.filters;
    const [focusDate, setFocusDate] = useState(false);
    return (
        <FilterChip
            label="Last scan"
            value={lastScanChipValue(lastScan, lastScanSince, formatDateOnly)}
        >
            {(close) => (
                <>
                    <ChipOptionList<LastScanPreset>
                        options={LAST_SCAN_OPTIONS}
                        selected={lastScan}
                        onSelect={(next) => {
                            browse.updateFilters({ lastScan: next });
                            setFocusDate(next === 'since');
                            if (next !== 'since') close('choice');
                        }}
                    />
                    {lastScan === 'since' && (
                        <div className="flex border-t border-gray-100 px-2.5 pb-1.5 pt-2.5">
                            <ChipDateField
                                label="Scanned on or after"
                                value={lastScanSince}
                                max={today}
                                autoFocus={focusDate}
                                onChange={(value) => browse.updateFilters({ lastScanSince: value })}
                                onDone={() => close('choice')}
                            />
                        </div>
                    )}
                </>
            )}
        </FilterChip>
    );
}

export function PatientFilterBar({ browse, today }: PatientFilterBarProps) {
    return (
        <FilterBar
            label="Patient filters"
            chips={<LastScanChip browse={browse} today={today} />}
            isUpdating={browse.isUpdating}
            showClear={browse.showClear}
            onClear={browse.clearFilters}
        />
    );
}
